import facebookIcon from 'Style/icons/logos/facebook.svg';
import instagramIcon from 'Style/icons/logos/instagram.svg';
import linkedinIcon from 'Style/icons/logos/linkedin.svg';
import AMEX from 'Style/icons/logos/payment/AMEX.svg';
import ApplePay from 'Style/icons/logos/payment/ApplePay.svg';
import Bancontact from 'Style/icons/logos/payment/Bancontact.svg';
import Blik from 'Style/icons/logos/payment/Blik.svg';
import CartaSi from 'Style/icons/logos/payment/CartaSi.svg';
import CartesBancaires from 'Style/icons/logos/payment/CartesBancaires.svg';
import Dankort from 'Style/icons/logos/payment/Dankort.svg';
import DotPay from 'Style/icons/logos/payment/DotPay.svg';
import Entercash from 'Style/icons/logos/payment/Entercash.svg';
import Eps from 'Style/icons/logos/payment/Eps.svg';
import Giropay from 'Style/icons/logos/payment/Giropay.svg';
import GooglePay from 'Style/icons/logos/payment/GooglePay.svg';
import iDEAL from 'Style/icons/logos/payment/iDEAL.svg';
import Klarna from 'Style/icons/logos/payment/Klarna.svg';
import Maestro from 'Style/icons/logos/payment/Maestro.svg';
import Mastercard from 'Style/icons/logos/payment/Mastercard.svg';
import MBWAY from 'Style/icons/logos/payment/MBWAY.svg';
import MobilePay from 'Style/icons/logos/payment/MobilePay.svg';
import PayPal from 'Style/icons/logos/payment/PayPal.svg';
import PostePay from 'Style/icons/logos/payment/PostePay.svg';
import Sofort from 'Style/icons/logos/payment/Sofort.svg';
import Trustly from 'Style/icons/logos/payment/Trustly.svg';
import Twint from 'Style/icons/logos/payment/Twint.svg';
import Vipps from 'Style/icons/logos/payment/Vipps.svg';
import Visa from 'Style/icons/logos/payment/Visa.svg';

export const RENDER_NEWSLETTER = 'render_newsletter';
export const NEWSLETTER_ACTIVE = 'newsletterActive';
export const HORIZONTAL = 'horizontal';

export const NEWSLETTER_COLUMN = {
    columnActiveKey: 'newsletterActive',
    items: [
        {
            render: RENDER_NEWSLETTER
        }
    ]
};

// eslint-disable-next-line import/prefer-default-export
// eslint-disable
export const COLUMN_MAP = [
    {
        title: __('About Bodymod'),
        expandable: true,
        items: [
            {
                href: '/about-bodymod',
                title: __('About Us FFFFF')
            },
            {
                href: 'https://get.bodymod.support/hc/en-us/articles/4403006107409-All-about-piercings',
                title: __('Blog')
            },
            {
                href: '/terms-and-conditions',
                title: __('Terms & conditions')
            },
            {
                href: 'https://get.bodymod.support/hc/en-us/articles/360009248857-Contact-us',
                title: __('Contact us')
            }
        ]
    },
    {
        title: __('Help & Info'),
        expandable: true,
        items: [
            {
                href: '/size',
                title: __('Size guide')
            },
            {
                href: 'https://get.bodymod.support/hc/en-gb/articles/360003231718-How-can-I-track-my-order-',
                title: __('Track order')
            },
            {
                href: '/delivery-time',
                title: __('Delivery information')
            },
            {
                href: 'https://get.bodymod.support/hc/en-gb/sections/360005973957-Returns',
                title: __('Returns & cancellation')
            },
            {
                href: 'https://get.bodymod.support/hc/en-gb/sections/360006027358-Payment',
                title: __('Payment')
            },
            {
                href: '/customer/account/login/',
                title: __('My account')
            },
            {
                href: '',
                title: __('Bodymod support')
            }
        ]
    },
    {
        title: __('Explore'),
        expandable: true,
        items: [
            {
                href: 'https://get.bodymod.support/hc/en-gb/articles/4403073452817',
                title: __('Types of piercings')
            },
            {
                href: 'https://get.bodymod.support/hc/en-gb/articles/4403066857873',
                title: __('Piercing jewelry materials')
            },
            {
                href: 'https://get.bodymod.support/hc/en-gb/articles/4403073480721',
                title: __('Jewelry types for piercings')
            },
            {
                href: 'https://get.bodymod.support/hc/en-gb/articles/4403066857873',
                title: __('Piercing aftercare')
            }
        ]
    },
    NEWSLETTER_COLUMN
];

export const SOCIAL_LINKS = [
    {
        isItemsHorizontal: true,
        items: [
            {
                href: 'https://www.facebook.com/Bodymod.eu',
                src: facebookIcon,
                title: __('Facebook'),
                isOpenInNewTab: true
            },
            {
                href: 'https://www.instagram.com/bodymod.eu/',
                src: instagramIcon,
                title: __('Instagram'),
                isOpenInNewTab: true
            },
            {
                href: 'https://www.linkedin.com/company/blue-monkeys-in-space',
                src: linkedinIcon,
                title: __('Linkedin'),
                isOpenInNewTab: true
            }
        ]
    }
];

export const LEGAL_LINKS = [
    {
        isItemsHorizontal: true,
        items: [
            {
                href: '/terms-and-conditions/#personal-information',
                title: __('Privacy Policy')
            },
            {
                href: '/cookie-settings',
                title: __('Cookie Settings')
            }
        ]
    }
];

export const PAYMENT_CARDS = {
    isItemsHorizontal: true,
    items: {
        Visa,
        Mastercard,
        Maestro,
        PayPal,
        GooglePay,
        ApplePay,
        AMEX,
        iDEAL,
        Vipps,
        Klarna,
        Bancontact,
        MBWAY,
        Entercash,
        Giropay,
        CartaSi,
        DotPay,
        Dankort,
        PostePay,
        Trustly,
        Eps,
        Blik,
        MobilePay,
        Sofort,
        Twint,
        CartesBancaires
    }
};
